import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./railwayStoreModule";

export default function useRailway() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'number',
        label: 'код',
      },
      { key: 'railway',
        label: 'название',
      },
      { key: 'short_name',
        label: 'короткое',
      },
      { key: 'country',
        label: 'страна',
      },
      { key: 'uic_code',
        label: 'UIC',
      },
  ])

  const setupData = {
      formModel: {
          name:'',
          number: '',
          user: '',
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
